import './Footer.css';

function Footer() {
  return (
    <footer>
      <div className="footer_line"></div>
      <div className="footer_container">
        <span className="footer_text">Gautheron Olivia © 2025</span>
      </div>
    </footer>
  );
}

export default Footer;
